module.exports = __webpack_public_path__ + "img/blockshape_z.b570eb4d.png";